import { useCallback, useEffect, useState } from "react";
import { Button } from "../../components/ui/button.tsx";
import { apiRequest } from "../../lib/http.ts";

interface Diagnostics {
  overall: string;
  checks: Array<
    { name: string; status: string; latencyMs?: number; details: string; lastChecked: string }
  >;
  environment: { env: string; timezone: string; nodeDenoVersion: string; uptimeSeconds: number };
  lastErrors: Array<{ timestamp: string; service: string; message: string }>;
}

export function DiagnosticsPage() {
  const [data, setData] = useState<Diagnostics | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await apiRequest<Diagnostics>("/api/v1/diagnostics"));
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível carregar o diagnóstico.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Diagnóstico do sistema</h3>
        <Button variant="outline" onClick={() => void load()} disabled={loading}>
          Atualizar
        </Button>
      </div>
      {error && (
        <div
          role="alert"
          className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive"
        >
          {error}
        </div>
      )}
      {loading && !data
        ? <div className="h-40 animate-pulse rounded-lg bg-muted" aria-busy="true" />
        : (
          <pre className="overflow-auto rounded-lg border bg-card p-5 text-xs leading-5">
          {JSON.stringify(data, null, 2)}
          </pre>
        )}
    </div>
  );
}
